import { ModalInput } from "components/atoms/input/modal/ModalInput";
import { useState } from "react";
import styled from "styled-components";
import { ValidateWord } from "components/atoms/text/Text";
import {
  CustomError,
  ValidateMsg,
} from "api/interfaces/commonInterface.interface";
import TextArea from "components/atoms/input/TextArea";
import BigPopupTemplate from "components/templates/modal/big/BigPopupTemplate";
import { ButtonWrapper } from "styles/ModalCommonStyled";
import BigButton from "components/atoms/buttons/BigButton";
import Input from "components/atoms/input/Input";
import useStatusMutation from "hook/useStatusMutation";
import { postRequestSendEmail } from "api/subscriptionAPI";
import useApiError from "hook/useApiError";
import {
  CpRequestInfo,
  SubscriptionRequestTable,
} from "api/interfaces/subscription.interface";
import SubscriptionOrgLabel from "components/atoms/text/labels/SubscriptionOrgLabel";
import { toTrim } from "utils/functions";

const initialValidateMsg = {
  title: "",
  message: "",
};

export default function EmailToRequesterModal({
  onModal,
  onCloseEmailToRequesterModal,
  requestInfo,
  requestItem,
}: {
  onModal: () => void;
  onCloseEmailToRequesterModal: () => void;
  requestInfo: CpRequestInfo;
  requestItem: SubscriptionRequestTable;
}) {
  const [data, setData] = useState<ValidateMsg>({ ...initialValidateMsg });
  const [validateMsg, setValidateMsg] = useState<ValidateMsg>({
    ...initialValidateMsg,
  });
  const { handleErrorNotify, intlString, lang, notifySuccess } = useApiError();
  const mutationRequestSendEmail = useStatusMutation(postRequestSendEmail, {
    onSuccess: () => {
      notifySuccess(lang.label.common.notify.email.success);
      onCloseEmailToRequesterModal();
    },
    onError: (err: CustomError) => {
      handleErrorNotify(err, lang.ServerErrorCode[121014]);
    },
  });
  const onSendEmail = () => {
    if (!mutationRequestSendEmail.idle) return;
    const trimData = {
      title: toTrim(data.title),
      message: toTrim(data.message),
    }
    setData(trimData);
    if (trimData.title === "") {
      setValidateMsg({
        ...initialValidateMsg,
        title: intlString(lang.label.subscription.sendEmail.title.empty),
      });
      return;
    }
    if (trimData.message === "") {
      setValidateMsg({
        ...initialValidateMsg,
        message: intlString(lang.label.subscription.sendEmail.empty),
      });
      return;
    }
    mutationRequestSendEmail.mutate({
      accountId: requestInfo.accountId,
      payload: {
        email: [requestItem.requester],
        title: trimData.title,
        message: trimData.message,
        id: requestItem.id,
      },
    });
  };
  return (
    <BigPopupTemplate title="Email to Requester" onModal={onModal}>
      <Wrapper>
        <SubscriptionOrgLabel
          accountName={requestInfo.accountName}
          accountNumber={requestInfo.accountNumber}
          accountLevel={requestInfo.accountLevel}
        />

        <ModalInput label="Recipient" essential>
          <Input
            value={requestItem.requester}
            name="requester"
            disabled
            data-testid="subscription-modal-torequester-requester-change"
          />
        </ModalInput>
        <ModalInput
          label="Title"
          essential
          isValidated={validateMsg.title !== ""}
        >
          <Input
            placeholder="Enter your title here."
            value={data.title}
            name="title"
            onChange={(e) => setData({ ...data, title: e.target.value })}
            data-testid="subscription-modal-torequester-title"
          />

          {validateMsg.title && (
            <ValidateWord data-testid="subscription-modal-torequester-validate-title">
              {validateMsg.title}
            </ValidateWord>
          )}
        </ModalInput>
        <ModalInput label="Send a Message to Your Requester" essential>
          <TextArea
            placeholder="Please enter a message."
            value={data.message}
            name="message"
            onChange={(e) => setData({ ...data, message: e.target.value })}
            isValidated={validateMsg.message !== ""}
            data-testid="subscription-modal-torequester-message"
          />

          {validateMsg.message && (
            <ValidateWord data-testid="subscription-modal-torequester-validate-message">
              {validateMsg.message}
            </ValidateWord>
          )}
        </ModalInput>
      </Wrapper>
      <ButtonWrapper>
        <BigButton
          label={"Back"}
          buttonType="cancel"
          onClickBtn={() => {
            onCloseEmailToRequesterModal();
          }}
          data-testid="subscription-modal-torequester-button-close-torequester-modal"
        />

        <BigButton
          label="Send Email"
          onClickBtn={onSendEmail}
          data-testid="subscription-modal-torequester-button-send-email"
        />
      </ButtonWrapper>
    </BigPopupTemplate>
  );
}

const Wrapper = styled.div`
  width: 100%;

  textarea {
    height: 400px;
  }
`;
